import { buildInspectionPortalLicenseUrl } from "@/components/inspection/dispatch-page";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Info } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

/** Absolute URL a phone can open to perform this property's inspection. */
export function inspectionPerformUrl(licenseId: string): string {
  if (typeof window === "undefined") {
    return buildInspectionPortalLicenseUrl(licenseId);
  }
  return `${window.location.origin}${buildInspectionPortalLicenseUrl(licenseId)}`;
}

export function InspectionPerformQr({ licenseId }: { licenseId: string }) {
  const url = inspectionPerformUrl(licenseId);
  return (
    <div className="flex items-start gap-2">
      <QRCodeSVG
        value={url}
        size={112}
        level="M"
        aria-label="QR code to perform this inspection on a mobile device"
        className="rounded-md border bg-white p-1"
      />
      <SelfInspectionInfo />
    </div>
  );
}

function SelfInspectionInfo() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-5 w-5 shrink-0 text-muted-foreground"
          aria-label="Self-inspection information"
        >
          <Info className="h-3 w-3" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 text-sm">
        <p className="font-medium">Self-inspections</p>
        <p className="mt-1 text-muted-foreground">
          Self-inspections are completed on a mobile device at the property.
        </p>
        <ol className="mt-2 list-decimal space-y-1 pl-4 text-muted-foreground">
          <li>Scan this QR code with the phone camera.</li>
          <li>Sign in if the inspection portal asks you to.</li>
          <li>Answer the inspection questions and add any required photos.</li>
          <li>Submit the inspection when it is complete.</li>
        </ol>
      </PopoverContent>
    </Popover>
  );
}
